import React, { HTMLAttributes, useLayoutEffect, useRef, useState } from "react";
import { Resizable } from "react-resizable";

interface CellProps extends HTMLAttributes<HTMLElement> {
  width: number | string;
  onResize: (e: React.SyntheticEvent, data: { size: { width: number } }) => void;
}

function ResizableTitle({ onResize, width, ...restProps }: CellProps) {
  const thRef = useRef<HTMLTableCellElement>(null);
  const [pixelWidth, setPixelWidth] = useState<number>(typeof width === "number" ? width : 0);

  useLayoutEffect(() => {
    if (typeof width === "string" && thRef.current) {
      setPixelWidth(thRef.current.offsetWidth);
    }
  }, []);

  const resolvedWidth = typeof width === "number" ? width : pixelWidth;

  if (!resolvedWidth) {
    return <th ref={thRef} {...restProps} />;
  }

  return (
    <Resizable
      width={resolvedWidth}
      height={0}
      handle={
        <span
          className="react-resizable-handle"
          onClick={(e) => {
            e.stopPropagation();
          }}
        />
      }
      onResize={onResize}
      draggableOpts={{ enableUserSelectHack: false }}
    >
      <th ref={thRef} {...restProps} />
    </Resizable>
  );
}

export default ResizableTitle;
